<template>
	<div style="width: 100%;height: 100%;">
		<div style="margin-top: 20%;margin-left: 5%;">
			<div @click="toActive('登陆')" :style="{float: 'left',padding:'5px 0px','font-size':'22px','font-weight':'900','border-bottom':active == '登陆'?'4px solid #66CBF7':'0px'}">
				登陆
			</div>
			<div @click="toActive('注册')" :style="{float: 'left','margin-left':'20px',padding:'5px 0px','font-size':'22px','font-weight':'900','border-bottom':active == '注册'?'4px solid #66CBF7':'0px'}">
				注册
			</div>
		</div>
		<div style="padding-top:100px;margin-left: 5%;margin-right: 5%;">
			<div style="padding-bottom: 8px;border-bottom: 1px solid #E6E6E6;">
				<img src="../../assets/fImage/4.png" style="width: 30px;margin-top: 5px;height: 30px;float: left;">
				<input placeholder="请输入手机号" v-model="phone" oninput="if(value.length > 11)value = value.slice(0, 11)" type="number" style="border: 0px;width: calc(100% - 50px);font-size: 16px;padding-left: 5px;">
			</div>
			<div v-if="active == '注册'" style="padding-bottom: 8px;padding-top:50px;border-bottom: 1px solid #E6E6E6;">
				<img src="../../assets/fImage/6.png" style="width: 26px;height: 26px;float: left;margin-right: 2px;margin-top: 5px;margin-left: 2px;">
				<input placeholder="请输入验证码" v-model="code" type="number" oninput="if(value.length > 4)value = value.slice(0, 4)" style="border: 0px;width: calc(100% - 180px);font-size: 16px;padding-left: 5px;">
				<div @click="sendSms" style="float: right;color: #00A9F2;font-size: 14px;">{{ time }}</div>
			</div>
			<div style="padding-bottom: 8px;padding-top:50px;border-bottom: 1px solid #E6E6E6;">
				<img src="../../assets/fImage/5.png" style="width: 30px;margin-top: 5px;height: 30px;float: left;">
				<input placeholder="请输入密码" v-model="pass" oninput="if(value.length > 13)value = value.slice(0, 13)" type="password" style="border: 0px;width: calc(100% - 50px);font-size: 16px;padding-left: 5px;">
			</div>
			<div v-if="active == '注册'" style="padding-bottom: 8px;padding-top:50px;border-bottom: 1px solid #E6E6E6;">
				<img src="../../assets/fImage/5.png" style="width: 30px;margin-top: 5px;height: 30px;float: left;">
				<input placeholder="请再次输入密码" v-model="rPass" oninput="if(value.length > 13)value = value.slice(0, 13)" type="password" style="border: 0px;width: calc(100% - 50px);font-size: 16px;padding-left: 5px;">
			</div>
			<div @click="forget" style="margin-top: 10px;text-align: right;color: #00A9F2;font-size: 12px;">
				忘记密码？
			</div>
			<div @click="loginF" v-if="active == '登陆'" style="font-size: 14px;margin-top: 50px;text-align: center;border-radius: 5px;height: 45px;line-height: 45px;background-color: #00A9F2;color: white;">
				登 陆
			</div>
			<div @click="siginIn" v-if="active == '注册'" style="font-size: 14px;margin-top: 50px;text-align: center;border-radius: 5px;height: 45px;line-height: 45px;background-color: #00A9F2;color: white;">
				注 册
			</div>
		</div>

	</div>
</template>

<script>
	import {sms,login,addUser} from "@/api/reservation";
	import Cookies from 'js-cookie';
	export default {
		name: "Index",
		data() {
			return {
				active:'登陆',
				time:'获取验证码',
				phone:'',
				code:'',
				pass:'',
				rPass:'',
				timer:null,
				flag:true
			}
		},
		created(){
			let cont = Cookies.get('cont');
			if(!cont){
				Cookies.set('cont', 1);
				location.reload();
			}
		},
		mounted() {
		},
		methods: {
			toActive(item) {
				this.active = item
			},
			forget(){
				Cookies.remove('cont');
				this.$router.push(
					{
						path:'/phone/forgetPass',
					}
				);
			},
			sendSms(){
				let _this = this
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
				if(!reg.test(this.phone)){
					_this.$message.error("请输入正确的手机号")
					return;
				}
				if(this.flag){
					sms(this.phone).then(data => {
						console.log(data)
						if(data.data == 'success'){
							_this.$message.success("发送成功")
							_this.flag = false
							_this.time = 60
							_this.code = ''
							_this.timer = setInterval(() => {
								_this.time--;
								if(_this.time == 0){
									_this.time = '获取验证码'
									clearInterval(_this.timer);
									_this.flag = true
								}
							}, 1000);
						}else{
							_this.$message.error("发送失败："+data.data)
						}
					}).catch(error =>{
						_this.$message.error(error)
					})
				}
			},
			loginF(){
				let _this = this
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
				if(!reg.test(this.phone)){
					_this.$message.error("请输入正确的手机号")
					return;
				}
				if(!this.pass){
					_this.$message.error("密码不可为空")
					return;
				}
				let param = {}
				param.phone = this.phone
				param.password = this.pass
				login(param).then(data => {
						console.log(data)
						if(data.data){
							_this.$message.success("登陆成功")
							Cookies.remove('cont');
							Cookies.set('phone', data.data.phone);
							_this.$router.push(
								{
									path:'/phone/index',
								}
							);
						}else{
							_this.$message.error("登陆失败：手机号或密码错误")
						}
					}).catch(error =>{
						_this.$message.error(error)
					})
			},
			siginIn(){
				let _this = this
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
				if(!reg.test(this.phone)){
					_this.$message.error("请输入正确的手机号")
					return;
				}
				if(!this.pass){
					_this.$message.error("密码不可为空")
					return;
				}
				if(!this.pass == this.rPass){
					_this.$message.error("两次输入密码不一致")
					return;
				}
				if(!this.code || this.code.length != 4){
					_this.$message.error("请输入正确的验证码")
					return;
				}
				let param = {}
				param.phone = this.phone
				param.password = this.pass
				param.code = this.code
				addUser(param).then(data => {
						console.log(data)
						if(data.data.resCode == 1){
							_this.$message.success("注册成功，正在自动登陆")
							Cookies.remove('cont');
							Cookies.set('phone', data.data.phone);
							_this.$router.push(
								{
									path:'/phone/index',
								}
							);
						}else if(data.data.resCode == -2){
							_this.$message.error("验证码错误")
						}else if(data.data.resCode == -1){
							_this.$message.error("当前手机号已注册")
						}else{
							_this.$message.error("注册失败")
						}
					}).catch(error =>{
						_this.$message.error(error)
					})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
